import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject } from "rxjs";

export interface PageLink {
  title: string;
  path: string;
  isActive: boolean;
  isSeparator?: boolean;
  params?: object;
}

export class PageInfo {
  breadcrumbs: Array<PageLink> = [];
  title: string = "";
}

@Injectable({
  providedIn: "root",
})
export class PageInfoService {
  public title: BehaviorSubject<string> = new BehaviorSubject<string>("Home");
  public description: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public breadcrumbs: BehaviorSubject<Array<PageLink>> = new BehaviorSubject<
    Array<PageLink>
  >([]);

  constructor(
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService
  ) {}

  public setTitle(_title: string) {
    this.title.next(_title);
  }

  public updateTitle(_title: string) {
    setTimeout(() => {
      this.setTitle(_title);
    }, 1);
  }

  public setDescription(_title: string) {
    this.description.next(_title);
  }

  public updateDescription(_description: string) {
    setTimeout(() => {
      this.setDescription(_description);
    }, 1);
  }

  public setBreadcrumbs(_bs: Array<PageLink>) {
    this.breadcrumbs.next(_bs);
  }

  public updateBreadcrumbs(_bs: Array<PageLink>) {
    setTimeout(() => {
      this.setBreadcrumbs(_bs);
    }, 20);
  }

  public calculateTitle() {
    const currentTitle = this.getRouteTitles().currentTitle;
    const translateTitle = currentTitle
      ? this.translate.instant(currentTitle?.toString())
      : "";
    const asideTitle =
      this.calculateTitleInMenu("kt_app_sidebar") || translateTitle || "";
    const headerTitle =
      this.calculateTitleInMenu("kt_app_header_wrapper") ||
      translateTitle ||
      "";
    const title = asideTitle || headerTitle || "";

    this.setTitle(title);
  }

  public calculateTitleInMenu(menuId: string): string | undefined {
    const menu = document.getElementById(menuId);
    if (!menu) {
      return;
    }

    const allActiveMenuLinks = Array.from<HTMLLinkElement>(
      menu.querySelectorAll("a.menu-link")
    ).filter((link) => link.classList.contains("active"));

    if (!allActiveMenuLinks || allActiveMenuLinks.length === 0) {
      return;
    }

    const titleSpan = allActiveMenuLinks[0].querySelector(
      "span.menu-title"
    ) as HTMLSpanElement | null;
    if (!titleSpan) {
      return;
    }

    return titleSpan.innerText;
  }

  public calculateBreadcrumbs() {
    //Custom Bc by rout snapshot
    const parentTitle = this.getRouteTitles().parentTitle;
    const translateTitle = parentTitle
      ? this.translate.instant(parentTitle?.toString())
      : "";
    let csBC: {
      isActive: boolean;
      isSeparator: boolean;
      path: string;
      title: any;
    }[] = [];
    if (this.getRouteTitles().parentUrl && parentTitle) {
      csBC = [
        {
          isActive: false,
          isSeparator: false,
          path: this.getRouteTitles().parentUrl,
          title: translateTitle,
        },
        {
          isActive: false,
          isSeparator: true,
          path: "",
          title: "",
        },
      ];
    }

    //Theme Default BC
    const asideBc = this.calculateBreadcrumbsInMenu("kt_app_sidebar") || csBC;
    const headerBc =
      this.calculateBreadcrumbsInMenu("kt_app_header_wrapper") || csBC;
    const bc = asideBc && asideBc.length > 0 ? asideBc : headerBc;

    if (!bc) {
      this.setBreadcrumbs([]);
      return;
    }
    this.setBreadcrumbs(bc);
  }

  public calculateBreadcrumbsInMenu(
    menuId: string
  ): Array<PageLink> | undefined {
    const result: Array<PageLink> = [];
    const menu = document.getElementById(menuId);
    if (!menu) {
      return;
    }

    const allActiveParents = Array.from<HTMLDivElement>(
      menu.querySelectorAll("div.menu-item")
    ).filter((link) => link.classList.contains("here"));

    if (!allActiveParents || allActiveParents.length === 0) {
      return;
    }

    allActiveParents.forEach((parent) => {
      const titleSpan = parent.querySelector(
        "span.menu-title"
      ) as HTMLSpanElement | null;
      if (!titleSpan) {
        return;
      }

      const title = titleSpan.innerText;
      const path = titleSpan.getAttribute("data-link");
      if (!path) {
        return;
      }

      result.push({
        title,
        path,
        isSeparator: false,
        isActive: false,
      });
      // add separator
      result.push({
        title: "",
        path: "",
        isSeparator: true,
        isActive: false,
      });
    });

    return result;
  }

  public getRouteTitles() {
    const currentRoute = this.activatedRoute;
    let current = this.activatedRoute;
    while (current.firstChild) {
      current = current.firstChild;
    }

    const currentTitle = current.snapshot.routeConfig?.title as string;
    const parentTitle = current.parent?.snapshot.routeConfig?.title as string;
    var parentUrl =
      "/" + current.parent?.snapshot.url.map((seg) => seg.path).join("/");
    var currentUrl =
      "/" + current.snapshot.url.map((seg) => seg.path).join("/");

    if (currentUrl === "/") {
      currentUrl = parentUrl!;
      parentUrl = "";
    } else if (parentUrl === "/") {
      parentUrl = "";
    }

    return { currentTitle, parentTitle, currentUrl, parentUrl };
  }
}
